import { initContract } from "@ts-rest/core";
import { z } from "zod";

import {
  LayoutSchema,
  MaterialLayoutWithRelationsSchema,
  QuoteRequestLineWithRelationsSchema,
} from "../generated/prisma/zod";

const c = initContract();

export const layoutsContract = c.router({
  findOne: {
    path: "/layouts/:id",
    method: "GET",
    responses: {
      200: LayoutSchema.merge(
        z.object({
          materialLayout: z.lazy(() => MaterialLayoutWithRelationsSchema).nullable(),
          quoteRequestLine: z.lazy(() => QuoteRequestLineWithRelationsSchema).nullable(),
        }),
      ),
    },
  },
  updateLayout: {
    method: "PATCH",
    path: "/layouts/:id",
    body: LayoutSchema.omit({
      id: true,
      quoteRequestId: true,
      appliedNestingRunId: true,
    })
      .partial()
      .extend({
        quoteRequestLineId: z.string().uuid(),
      }),
    responses: {
      200: LayoutSchema,
    },
  },
});
